export default "__VITE_ASSET__dcc5ced0__"